import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setInitMessage } from '../../actions/CommonAction';
import UploadJobListComponent from './UploadJobListComponent';
import UploadAreaComponent from './UploadAreaComponent';
import styles from './UploadCompanyInfoComponent.module.css';

class UploadCompanyInfoComponent extends Component {
  componentDidMount() {
    // Google Analytics
    window.gtagPageview();
  }

  componentWillUnmount() {
    const { setInitMessageAct } = this.props;
    setInitMessageAct();
  }

  render() {
    return (
      <div className={`${styles.uploadcompanyinfo}`}>
        <div className={`${styles.container}`}>
          <UploadJobListComponent />
          <div className={`${styles.container2}`}>
            <UploadAreaComponent />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  null,
  (dispatch) => ({
    setInitMessageAct: () => dispatch(setInitMessage()),
  }),
)(UploadCompanyInfoComponent);
